<template>
    <section>
        <HeaderPage :screen_width="screen_width" />
        <PersonalInformation
            :to="to"
            :req="req"
            :member_model="member_model"
            :is-requesting="isRequesting"
            :loading="loading"
            @changeIsReq="changeIsReq"
        />
        <AccountInformation />
        <v-form ref="form">
            <ToHospClinDoc
                :to="to"
                :member_model="member_model"
                :screen_width="screen_width"
                :loading="loading"
            />
            <Reason
                @saveReason="saveReason"
                @saveMedicoLegal="saveMedicoLegal"
            />
        </v-form>
        <IsRequesting
            :is-requesting="isRequesting"
            :loading="loading"
            @changeIsReq="changeIsReq"
        />
        <v-form ref="form_2">
            <v-expand-transition>
                <ReqHospClinDoc
                    v-show="isRequesting"
                    :req="req"
                    :member_model="member_model"
                    :screen_width="screen_width"
                    :loading="loading"
                />
            </v-expand-transition>
        </v-form>
        <p class="text-center">
            <v-btn
                class="teal white--text"
                :loading="isFormSubmitted"
                style="font-weight: 700; font-size: 17px; margin: 20px 0"
                @click="submit()"
            >
                SUBMIT
            </v-btn>
        </p>
    </section>
</template>

<script>
import HeaderPage from './HeaderPage.vue'
import PersonalInformation from './PersonalInformation.vue'
import AccountInformation from './AccountInformation.vue'
import ToHospClinDoc from './ToHospClinDoc.vue'
import Reason from './Input/Reason.vue'
import IsRequesting from './IsRequesting.vue'
import ReqHospClinDoc from './ReqHospClinDoc.vue'
import { mapActions } from 'vuex'
import ClientPortal from './../../../../plugins/axios'

export default {
    components: { HeaderPage, PersonalInformation, AccountInformation, ToHospClinDoc, Reason, IsRequesting, ReqHospClinDoc },
    data: ()=>({
        loading: {
            main: false,
            to: {
                region: false,
                province: false,
                city: false,
                hospital: false,
                doctor: false
            },
            req: {
                region: false,
                province: false,
                city: false,
                hospital: false,
                doctor: false
            }
        },
        to: {
            hint: {
                doc: false
            },
            filter: {
                hosp: false,
                doc: false
            },
            region: '',
            province: '',
            city: '',
            facility: '',
            facilityCode: null,
            specField: { sp_name: 'ALL', sp_desc: '' },
            hospClinDoctor: '',
            hospClinDoctorCode: null,
            hospClinType: 'H',
            decking: ''
        },
        req: {
            hint:  {
                doc: false
            },
            filter: {
                hosp: false,
                doc: false
            },
            region: '',
            province: '',
            city: '',
            facility: '',
            facilityCode: null,
            specField: { sp_name: 'ALL', sp_desc: '' },
            hospClinDoctor: '',
            hospClinDoctorCode: null,
            hospClinType: 'H',
            decking: ''
        },
        text_reason: '',
        medico_legal: null,
        isFormSubmitted: false,
        isRequesting: false,
        member_model: '',
        screen_width: document.documentElement.clientWidth + 9,
        goToOptions: {
            duration: 500,
            offset: 130,
            easing: 'easeInOutCubic'
        }
    }),
    watch: {
        async isRequesting(newVal) {
            if (newVal) {
                this.loading.req.hospital = true
                await this.reqSpecialization()
                await this.reqRegions()
                this.loading.req.province = true
                await this.reqProvinces({ REGION: this.req.region })
                this.loading.req.hospital = true
                await this.reqHospClin({ REGION: this.req.region, PROVINCE: this.req.province, CITY: this.req.city, TYPE: '', MEMBN: this.$cookies.get('usermembn') })
            }
        }
    },
    async created() {
        this.loading.main = true
        await this.userConsult({ MEMBN: this.$cookies.get('usermembn') })
        await this.related_list({ MEMBN: this.$cookies.get('usermembn') })
        this.member_model = {
            MEMB_N: this.$store.getters.getRelated.PRIN_DEP[0].MEMB_N,
            LAST_M: this.$store.getters.getRelated.PRIN_DEP[0].LAST_M
        }
        await this.toSpecialization()
        await this.toRegions()
        this.loading.to.province = true
        await this.toProvinces({ REGION: this.to.region })
        this.loading.to.hospital = true
        await this.toHospClin({ REGION: this.to.region, PROVINCE: this.to.province, CITY: this.to.city, TYPE: '', MEMBN: this.$cookies.get('usermembn') })
        this.loading.main = false
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'userConsult', 'toRegions', 'toProvinces', 'toHospClin', 'reqRegions', 'reqProvinces', 'reqHospClin', 'verifyConsult', 'toSpecialization', 'reqSpecialization', 'related_list']),
        saveMedicoLegal(newVal) {
            this.medico_legal = newVal
        },
        saveReason(newVal) {
            this.text_reason = newVal
        },
        changeIsReq(value) {
            this.isRequesting = value
        },
        submit() {
            // Submit button method
            if(this.hospClinType === 'C' || String(this.to_decking).toUpperCase() ==='D' || String(this.to_decking).toUpperCase() === 'U' ) {
                this.$refs.combobox_1.blur()
            }
            if (this.isRequesting === true && (this.r_hospClinType === 'C' || String(this.req_decking).toUpperCase() === 'D' || String(this.req_decking).toUpperCase() === 'U')) {
                this.$refs.combobox_2.blur()
            }
            this.$nextTick(async () => {
                if (!this.$refs.form.validate() || (this.isRequesting && !this.$refs.form_2.validate())) {
                    this.$nextTick(()=>{
                        let el = document.querySelector('.v-messages.error--text:first-of-type')
                        if (el) this.$vuetify.goTo(el, this.goToOptions)
                    })
                } else {
                    this.isFormSubmitted = true
                    let request_payload = {
                        REGION: this.req.region,
                        PROVINCE: this.req.province,
                        CITY: this.req.city,
                        HOSP_NAME: this.req.facility.hosp_name,
                        HOSP_CODE: this.req.facility.hosp_msu_code,
                        DOCTOR: this.req.hospClinDoctor !== null && String(this.req.hospClinDoctor).trim().length > 0 ? String(this.req.hospClinDoctor).toUpperCase() : '',
                        DOC_CODE: this.req.hospClinDoctorCode
                    }
                    let payload = {
                        MEMBN: this.member_model.MEMB_N,
                        REGION: this.to.region,
                        PROVINCE: this.to.province,
                        CITY: this.to.city,
                        HOSP_NAME: this.to.facility.hosp_name,
                        HOSP_CODE: this.to.facility.hosp_msu_code,
                        DOCTOR: this.to.hospClinDoctor !== null && String(this.to.hospClinDoctor).trim().length > 0 ? String(this.to.hospClinDoctor).toUpperCase() : '',
                        DOC_CODE: this.to.hospClinDoctorCode,
                        REASON: `${this.text_reason}\nVEHICULAR ACCIDENT OR MEDICO-LEGAL CASE? ${this.medico_legal ? 'YES' : 'NO'}`,
                        REQUEST: this.isRequesting ? request_payload : false,
                        MEDICO_LEGAL: this.medico_legal
                    }
                    // console.log('payload: ', payload)
                    await ClientPortal
                        .post(`${process.env.VUE_APP_API}/login/consultation/eligible`, { MEMBN: this.$cookies.get('usermembn') }, { withCredentials : true })
                        .then(async (response) => {
                            if (response.status == 200 && response.data.eligible == true)
                                await this.verifyConsult(payload)
                            else
                                this.$router.push('/dashboard/consultation/main/')
                        })
                        .catch(() => {
                            // console.log("Error: ", error)
                        })
                }
            })
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        }
    }
}
</script>

<style scoped>
section {
    width: 100%;
    padding: 0 20px;
    background-image: url("./../../../../assets/dashboardBG.webp");
    background-position: center;
    background-size: cover;
}
.nav {
    margin-top: 60px;
}
.nav h2 {
    font-size: 25px;
}
</style>
